interface LegalPlaceholderProps {
  title: string;
  description: string;
  icon: string;
}

export default function LegalPlaceholder({ title, description, icon }: LegalPlaceholderProps) {
  return (
    <div className="p-6">
      <div className="max-w-lg mx-auto mt-16 text-center">
        <div className="text-5xl mb-4">{icon}</div>
        <h1 className="text-2xl font-bold text-secondary-900 dark:text-white mb-3">
          {title}
        </h1>
        <p className="text-secondary-600 dark:text-secondary-400 mb-6">
          {description}
        </p>
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300 text-sm font-medium">
          Coming Soon
        </div>
      </div>
    </div>
  );
}
